import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CheckmarkWithSound} from '../Button/Button';
import './Build.scss';

const Build = (props) => {
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const { freeplay } = useSelector((state) => state.freeplay, shallowEqual);

    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
    
    const [selectedStudentText, setSelectedStudentText] = useState("")
    const [selectedFriendText, setSelectedFriendText] = useState("")
    const hasClicked = useRef(false); 
    const [chooseStudentConversation, setChooseStudentConversation] = useState(false);
    const [chooseFriendConversation, setChooseFriendConversation] = useState(false);
    const [conversation, setConversation] = useState(() => {
        // Creating a deep copy of the conversation (if needed, depending on the structure)
        return props.conversation.map(item => ({ ...item }));
    });
    const [index, setIndex] = useState(0)
    


    const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png')

    useEffect(() => {   
        if(index > props.instructions.length - 1) {
            props.setSelectedConversation(conversation);
            props.finish();
            return;
        };

        if(index % 2 === 0){
            setChooseStudentConversation(true)
        }   
        else{
            setChooseFriendConversation(true)
        }
    }, [index]);

    const goToPreviousTurn = () => {
        setConversation(prev => {
            if(props.topicNum === 8){
                conversation[props.order9[index - 1]].text = props.conversation[props.order9[index - 1]].text; // Update the string at that index
            }
            else if(props.topicNum === 9){
                conversation[props.order10[index - 1]].text = props.conversation[props.order10[index - 1]].text; // Update the string at that index
            }
            else{
                conversation[props.order[index - 1]].text = props.conversation[props.order[index - 1]].text; // Update the string at that index
            }
            return conversation; // Return the updated array
        });
        setIndex(index - 1);
        setSelectedStudentText("");
        setSelectedFriendText("");
        setChooseStudentConversation(!chooseStudentConversation)
        setChooseFriendConversation(!chooseFriendConversation)
    };

    const comnfirmConversation = () => {
        hasClicked.current = true; // Immediately block further clicks
        if(index % 2 === 0){
            setConversation(prev => {
                const updatedConversation = [...prev]; // Create a copy of the previous state
                if(props.topicNum === 8){
                    if(!updatedConversation[props.order9[index]].text.includes(selectedStudentText)) {
                        updatedConversation[props.order9[index]].text += selectedStudentText; // Update the string at that index
                    }
                }
                else if(props.topicNum === 9){
                    if(!updatedConversation[props.order10[index]].text.includes(selectedStudentText)) {
                        updatedConversation[props.order10[index]].text += selectedStudentText; // Update the string at that index
                    }
                }
                else{
                    if(props.title === "Active Listening" && index === 0 ){
                        if(!updatedConversation[props.order[index]].text.includes(selectedStudentText)){
                            updatedConversation[props.order[index]].text += selectedStudentText; // Update the string at that index
                            updatedConversation[1].text = updatedConversation[1].text.replace(new RegExp(props.topic, "gi"), selectedStudentText.slice(0, -1));
                            props.texts[2][0] = props.texts[2][0].replace(new RegExp(props.topic, "gi"), selectedStudentText.slice(0, -1));
                            props.texts[2][1] = props.texts[2][1].replace(new RegExp(props.topic, "gi"), selectedStudentText.slice(0, -1));
                            props.texts[2][3] = props.texts[2][3].replace(new RegExp(props.topic, "gi"), selectedStudentText.slice(0, -1));
                            props.texts[2][4] = props.texts[2][4].replace(new RegExp(props.topic, "gi"), selectedStudentText.slice(0, -1));
                        }
                    }
                    else{
                        if(!updatedConversation[props.order[index]].text.includes(selectedStudentText)){
                            updatedConversation[props.order[index]].text += selectedStudentText; // Update the string at that index
                        }
                    }
                }
                return updatedConversation; // Return the updated array
            });
            setSelectedStudentText("")
            setChooseStudentConversation(false)
        }   
        else{
            setConversation(prev => {
                const updatedConversation = [...prev]; // Create a copy of the previous state
                if(props.topicNum === 8){
                    if(!updatedConversation[props.order9[index]].text.includes(selectedFriendText)) {
                        updatedConversation[props.order9[index]].text += selectedFriendText; // Update the string at that index
                    }
                }
                else if(props.topicNum === 9){
                    if(!updatedConversation[props.order10[index]].text.includes(selectedFriendText)) {
                        updatedConversation[props.order10[index]].text += selectedFriendText; // Update the string at that index
                    }
                }
                else{
                    if(!updatedConversation[props.order[index]].text.includes(selectedFriendText)) {
                        updatedConversation[props.order[index]].text += selectedFriendText; // Update the string at that index
                    }
                }
                return updatedConversation; // Return the updated array
            });            
            setSelectedFriendText("")
            setChooseFriendConversation(false)
        }
        setIndex(index + 1);
    }


    return (
        <div className='buildBody'>
            <div className='buildHeader'>
                <h1 className="title">{props.title}: {props.subTitle}</h1>
                <p className="subtitle">Build Your Conversation</p>
            </div>
            
            {index !== 0 && <button onClick={goToPreviousTurn} className="paginate left"><i></i><i></i></button>}
            {chooseStudentConversation && <div className={`conversation-card ${props.selectedStudentCharacter.name}-turn`}>
                <div className="avatar-container">
                    <div className="avatar">
                        <img alt="seleted avatar" src={generateImageUrl(props.selectedStudentCharacter.src)}/>
                    </div>
                </div>

                <h2 className="section-title">{props.studentName}'s Turn</h2>

                <div className="greeting-selector">
                    <p className="greeting-label">{props.instructions[index]}:</p>
                    <div className="greeting-display">
                        <span className="greeting-text">{selectedStudentText}</span>
                    </div>
                    {/* <div className="message-icon-container">
                    </div> */}
                </div>

                <div className={`greeting-buttons`}>
                    {props.texts[index].map((option) => (
                        <button
                        key={option}
                        onClick={() => setSelectedStudentText(option)}
                        className={`greeting-button-${props.selectedStudentCharacter.name}`}
                        >
                        {option}
                        </button>
                    ))}
                </div>


            </div>}
            {chooseFriendConversation && <div className={`conversation-card ${props.selectedFriendCharacter.name}-turn`}>
                <div className="avatar-container">
                    <div className="avatar">
                        <img alt="seleted avatar" src={generateImageUrl(props.selectedFriendCharacter.src)}/>
                    </div>
                </div>

                <h2 className="section-title">{props.friendName}'s Turn</h2>

                <div className="greeting-selector">
                    <p className="greeting-label">{props.instructions[index]}:</p>
                    <div className="greeting-display">
                        <span className="greeting-text">{selectedFriendText}</span>
                    </div>
                    {/* <div className="message-icon-container">
                    </div> */}
                </div>

                <div className={`greeting-buttons`}>
                    {props.texts[index].map((option) => (
                        <button
                        key={option}
                        onClick={() => setSelectedFriendText(option)}
                        className={`greeting-button-${props.selectedFriendCharacter.name}`}
                        >
                        {option}
                        </button>
                    ))} 
                </div>


            </div>}
            {(selectedStudentText || selectedFriendText) && <CheckmarkWithSound className='checkMark' onClick={() => comnfirmConversation()} img={greenCheck}/>}

        </div>
    );
};
export default Build;
